export enum ExperienceGroup {
  HWJ_ON_GLP1_CONTINUATION = "HWJ_ON_GLP1_CONTINUATION",
  HWJ_ON_GLP1_CONTINUATION_NO_CONCIERGE_CARE = "HWJ_ON_GLP1_CONTINUATION_NO_CONCIERGE_CARE",
  HWJ_ELIGIBLE_FOR_MEDS = "HWJ_ELIGIBLE_FOR_MEDS",
  HWJ_NOT_ELIGIBLE_FOR_MEDS = "HWJ_NOT_ELIGIBLE_FOR_MEDS",
  EDJ_ON_GLP1_CONTINUATION = "EDJ_ON_GLP1_CONTINUATION",
  DIABETES_AND_HEART_DISEASE_PREVENTION_OR_ALL_IN_ONE = "DIABETES_AND_HEART_DISEASE_PREVENTION_OR_ALL_IN_ONE"
}
